import store from './store.js'
import './theme.less'
import init from '../init.js'
import {actions} from './siteActions.js'

init({
  store
}, actions)



// WEBPACK FOOTER //
// ./src/servicios_digitales_costa/index.js